/**
 * 门户tab默认配置数据
 */
export const home = [
  {

  },
  {
    styleId:2,
    quoteComponent:"cxSelect"
  }
]

/**
 * 大屏tab默认配置数据
 */
export const bs = [
  {},
  {
    styleId:2,
    quoteComponent:"cxSelect"
  }
]

/**
 * app tab默认配置数据
 */
export const appHome = [
  {},
  {
    styleId:2,
    quoteComponent:"cxSelect"
  }
]